module.exports = __webpack_public_path__ + "img/delete-red.ad269c96.svg";